import { useState, useEffect } from 'react';
import { Shield, Clock, MapPin, Users, Phone, Mail, ArrowRight, X, Truck} from 'lucide-react';
import PartnersCarousel from '../components/PartnersCarousel';

import { Menu } from 'lucide-react';
import Footer from '../components/Footer';
import DespreNoi from './DespreNoi';
import ProtectedEmail from '@/hooks/ProtectedEmail';
import FormContact from '@/hooks/FormContact';
import SEO from './admin/components/SEO';

const HomePage = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrollY, setScrollY] = useState(0);
  const [activeService, setActiveService] = useState(0);
  
 // Funcție îmbunătățită pentru smooth scroll care nu interferează cu input-urile
  const smoothScrollTo = (element, offset = 0) => {
    // Verifică dacă elementul țintă este un input, textarea sau formular
    if (element.tagName && ['INPUT', 'TEXTAREA', 'SELECT', 'FORM'].includes(element.tagName.toUpperCase())) {
      return; // Nu face scroll pentru aceste elemente
    }
    
    const targetPosition = element.getBoundingClientRect().top + window.pageYOffset - offset;
    const startPosition = window.pageYOffset;
    const distance = targetPosition - startPosition;
    const duration = 600;
    let startTime = null;

    const animation = (currentTime) => {
      if (!startTime) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      const run = easeInOutQuad(timeElapsed, startPosition, distance, duration);
      window.scrollTo(0, run);
      if (timeElapsed < duration) requestAnimationFrame(animation);
    };

    const easeInOutQuad = (t, b, c, d) => {
      t /= d/2;
      if (t < 1) return c/2*t*t + b;
      t--;
      return -c/2 * (t*(t-2) - 1) + b;
    };

    requestAnimationFrame(animation);
  };

const navigationItems = [
  { name: 'Acasă', href: '#', id: 'hero' }, // sau '' pentru top
  { name: 'Servicii', href: '#servicii', id: 'servicii' },
  { name: 'Despre Noi', href: '#despre', id: 'despre' }, // verifică ID-ul real
  { name: 'Contact', href: '#contact', id: 'contact' }
];
  useEffect(() => {
  let ticking = false;
  
  const handleScroll = () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        setScrollY(window.scrollY);
        ticking = false;
      });
      ticking = true;
    }
  };
  
  window.addEventListener('scroll', handleScroll, { passive: true });
  return () => window.removeEventListener('scroll', handleScroll);
}, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveService((prev) => (prev + 1) % 5);
    }, 3000);
    return () => clearInterval(interval);
  }, []);


  
  const services = [
    {
      icon: <Truck className="w-10 h-10 sm:w-12 sm:h-12 text-blue-500" />,
      title: "Transport Mărfuri",
      description: "Transport sigur și rapid pentru toate tipurile de mărfuri, cu urmărire în timp real și sistem GPS avansat.",
      gradient: "from-blue-50 to-blue-100",
      hoverGradient: "from-blue-500 to-blue-600",
      accent: "blue"
    },
    {
      icon: <Users className="w-10 h-10 sm:w-12 sm:h-12 text-emerald-500" />,
      title: "Livrare Rapidă",
      description: "Personal bine instruit și experimentat, capabil să îndeplinească sarcinile în timp util și să livreze mărfurile în cel mai scurt timp posibil.",
      gradient: "from-emerald-50 to-emerald-100",
      hoverGradient: "from-emerald-500 to-emerald-600",
      accent: "emerald"
    },
    {
      icon: <Shield className="w-10 h-10 sm:w-12 sm:h-12 text-teal-500" />,
      title: "Executare Sigură",
      description: "Siguranța mărfurilor este prioritatea noastră. Ne bazăm pe o serie de măsuri pentru a asigura că mărfurile ajung la destinație în siguranță.",
      gradient: "from-teal-50 to-teal-100",
      hoverGradient: "from-teal-500 to-teal-600",
      accent: "teal"
    },
    {
      icon: <Clock className="w-10 h-10 sm:w-12 sm:h-12 text-amber-500" />,
      title: "Punctualitate",
      description: "Respectăm întotdeauna termenele promise, cu opțiuni de livrare expresă în 24h pentru urgențe.",
      gradient: "from-amber-50 to-amber-100",
      hoverGradient: "from-amber-500 to-amber-600",
      accent: "amber"
    },
    {
      icon: <MapPin className="w-10 h-10 sm:w-12 sm:h-12 text-indigo-500" />,
      title: "Transparență Totală",
      description: "Oferim informații clare și precise cu privire la serviciile noastre, astfel încât să fiți la curent cu fiecare etapă.",
      gradient: "from-indigo-50 to-indigo-100",
      hoverGradient: "from-indigo-500 to-indigo-600",
      accent: "indigo"
    }
  ];

  return (
    <>
    <SEO 
  title="VGL Trans Express - Transport Profesional Mărfuri România | Sigur & Rapid"
  description="🚛 Transport profesional mărfuri în România. ✅ Siguranță garantată ⏰ Livrare rapidă 💰 Prețuri competitive. Peste 300 clienți mulțumiți. Contactează-ne!"
  keywords="transport marfuri Romania, logistica Cluj, transport profesional, depozitare marfuri, livrare rapida 24h, VGL Trans Express, transport sigur, servicii logistice Romania, transport national"
  image="https://vgltransexpress.com/hero-transport.png"
  url="https://vgltransexpress.com"
  type="website"
/>
    <div className="min-h-screen overflow-x-hidden">
      {/* Navigation */}
      <nav className={`fixed w-full z-50 transition-all duration-500 ${
        scrollY > 50 ? 'bg-slate-900/95 backdrop-blur-lg shadow-xl border-b border-slate-800/50' : 'bg-transparent'
      }`}>
        <div className="container mx-auto px-4 sm:px-6 py-3 sm:py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2 sm:space-x-3">
              <div className="flex items-center space-x-2">
                <img
                  src="/logo.png"
                  alt="VGL Logo"
                  className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 object-contain"
                />
                <span className="text-lg sm:text-xl md:text-2xl font-bold text-white">
                  VGL Trans Express
                </span>
              </div>
            </div>
            
            <div className="hidden md:flex items-center space-x-6 lg:space-x-8">
  {navigationItems.map((item) => (
    <a 
      key={item.name} 
      href={item.href}
      className="text-white/90 hover:text-white transition-colors duration-300 relative group font-medium"
    >
      {item.name}
      <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-blue-400 to-teal-400 group-hover:w-full transition-all duration-300"></span>
    </a>
  ))}

              <button
                onClick={() => {
                  const contactSection = document.getElementById('contact');
                  if (contactSection) {
                    smoothScrollTo(contactSection);
                  }
                }}
                className="bg-gradient-to-r from-blue-500 to-teal-500 hover:from-blue-600 hover:to-teal-600 text-white px-4 sm:px-6 py-2 sm:py-3 rounded-xl font-semibold transition-colors duration-300 shadow-lg hover:shadow-xl text-sm sm:text-base"
              >
                Solicită Ofertă
              </button>
            </div>

            <button 
              className="md:hidden text-white p-2"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
     <div 
  className={`fixed inset-0 z-40 bg-slate-900/98 backdrop-blur-lg transform transition-transform duration-300 md:hidden ${
    isMenuOpen ? 'translate-x-0' : 'translate-x-full'
  }`}
  style={{ 
    touchAction: 'none', // Schimbă din 'auto' în 'none' pentru a bloca toate gesturi
    overscrollBehavior: 'none', // Previne overscroll
    WebkitOverflowScrolling: 'touch' // Pentru iOS
  }}
>
  <div 
    className="flex flex-col items-center justify-center h-full space-y-8 text-xl sm:text-2xl px-4"
    style={{ 
      overflowY: 'hidden', // Asigură-te că nu există overflow
      overflowX: 'hidden'
    }}
  >
    {/* Conținutul meniului rămâne la fel */}
    {['Acasă', 'Servicii', 'Despre', 'Contact'].map((item) => (
      <a key={item} href={`#${item.toLowerCase()}`} 
         className="text-white hover:text-blue-400 transition-colors duration-300 font-medium"
         onClick={() => setIsMenuOpen(false)}>
        {item}
      </a>
    ))}
    <button
      onClick={() => {
        const contactSection = document.getElementById('contact');
        if (contactSection) {
          smoothScrollTo(contactSection);
        }
        setIsMenuOpen(false);
      }}
      className="bg-gradient-to-r from-blue-500 to-teal-500 text-white px-8 py-3 rounded-xl font-semibold mt-4"
    >
      Solicită Ofertă
    </button>
  </div>
</div>

      {/* Hero Section */}
      <section className="relative min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-teal-900 flex items-center overflow-hidden">
        {/* Background Image with Overlay */}
        <div className="absolute inset-0 z-0">
          <img 
            src="/hero-transport.png" 
            alt="Transport profesional" 
            className="w-full h-full object-cover opacity-60"
          />
          <div className="absolute inset-0 bg-gradient-to-br from-slate-900/80 via-blue-900/70 to-teal-900/80"></div>
        </div>
        
        {/* Animated Background Elements */}
        <div className="absolute inset-0 z-1">
          <div className="absolute top-1/4 left-1/4 w-32 h-32 sm:w-48 sm:h-48 md:w-64 md:h-64 bg-blue-500/10 rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute bottom-1/4 right-1/4 w-48 h-48 sm:w-64 sm:h-64 md:w-96 md:h-96 bg-teal-500/10 rounded-full blur-3xl animate-pulse delay-1000"></div>
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 sm:w-96 sm:h-96 md:w-128 md:h-128 bg-gradient-to-r from-blue-500/5 to-teal-500/5 rounded-full blur-3xl animate-spin-slow"></div>
        </div>
        
        <div className="container mx-auto px-4 sm:px-6 relative z-10 py-20 sm:py-24">
          <div className="max-w-6xl mx-auto">
            <div className="text-center lg:text-left">
              <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold text-white mb-6 sm:mb-8 leading-tight">
                În siguranță,{' '}
                <span className="animate-text-highlight-smooth relative inline-block">
                  la timp,
                </span>
                <br />
                 oriunde!
              </h1>
              
              <p className="text-lg sm:text-xl md:text-2xl text-slate-300 mb-8 sm:mb-12 max-w-4xl mx-auto lg:mx-0 leading-relaxed">
                Servicii profesionale de transport și depozitare pentru mărfuri în toată țara. 
                Siguranță garantată, punctualitate și prețuri competitive.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center lg:justify-start">
                <button
                  onClick={() => {
                    const contactSection = document.getElementById('contact');
                    if (contactSection) {
                       smoothScrollTo(contactSection);
                    }
                  }}
                  className="group bg-gradient-to-r from-blue-500 to-teal-500 hover:from-blue-600 hover:to-teal-600 text-white px-8 sm:px-10 py-4 sm:py-5 rounded-2xl font-bold text-base sm:text-lg transition-all duration-300 transform hover:scale-105 shadow-2xl hover:shadow-blue-500/25 flex items-center justify-center relative overflow-hidden"
                >
                  <span className="mr-3">Solicită Ofertă</span>
                  <ArrowRight className="w-5 h-5 sm:w-6 sm:h-6 group-hover:translate-x-1 transition-transform duration-300" />
                  <div className="absolute inset-0 bg-gradient-to-r from-blue-400 to-teal-400 rounded-2xl blur opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
                </button>

               
              </div>

              {/* Stats */}
              <div className="grid grid-cols-3 gap-4 sm:gap-8 mt-12 sm:mt-16 pt-12 sm:pt-16 border-t border-white/20 max-w-2xl mx-auto lg:mx-0">
                {[
                  { number: '5+', label: 'Ani Experiență' },
                  { number: '300+', label: 'Clienți Mulțumiți' },
                  { number: '99.8%', label: 'Punctualitate' }
                ].map((stat, index) => (
                  <div key={index} className="text-center">
                    <div className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold bg-gradient-to-r from-blue-400 to-teal-400 bg-clip-text text-transparent mb-2">
                      {stat.number}
                    </div>
                    <div className="text-slate-300 text-xs sm:text-sm uppercase tracking-wider">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="servicii" className="py-16 sm:py-20 md:py-24 bg-gradient-to-br from-slate-50 to-blue-50 relative overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute top-0 left-0 w-64 h-64 sm:w-96 sm:h-96 bg-blue-200/20 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-64 h-64 sm:w-96 sm:h-96 bg-teal-200/20 rounded-full blur-3xl"></div>
        </div>
        
        <div className="container mx-auto px-4 sm:px-6 relative z-10">
          <div className="text-center mb-12 sm:mb-16 md:mb-20">
            <div className="inline-block mb-4">
              <span className="bg-gradient-to-r from-blue-500 to-teal-500 text-white px-4 py-2 rounded-full text-sm font-semibold">
                SERVICII PREMIUM
              </span>
            </div>
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-slate-800 mb-4 sm:mb-6">
              Serviciile <span className="bg-gradient-to-r from-blue-600 to-teal-600 bg-clip-text text-transparent">Noastre</span>
            </h2>
            <p className="text-lg sm:text-xl text-slate-600 max-w-3xl mx-auto leading-relaxed px-4">
              Oferim soluții complete de transport adaptate perfect nevoilor dumneavoastră 
              și standard european de calitate
            </p>
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 md:gap-10 max-w-7xl mx-auto">
            {services.map((service, index) => (
              <div 
  key={index} 
  className={`group relative bg-white p-6 sm:p-8 rounded-2xl sm:rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 cursor-pointer overflow-hidden ${
    activeService === index ? 'ring-2 ring-blue-400/50 scale-[1.02]' : ''
  }`}
  onMouseEnter={() => setActiveService(index)}
  onMouseLeave={() => setActiveService((prev) => prev)} // Păstrează starea
>
                {/* Gradient Background */}
                <div className={`absolute inset-0 bg-gradient-to-br ${service.gradient} opacity-0 group-hover:opacity-100 transition-opacity duration-500`}></div>
                
                {/* Floating Icon Background */}
                <div className={`absolute -top-4 -right-4 w-20 h-20 sm:w-24 sm:h-24 bg-${service.accent}-100 rounded-full opacity-20 group-hover:scale-150 transition-transform duration-500`}></div>
                
                <div className="relative z-10">
                  <div className={`p-3 sm:p-4 ${
  service.accent === 'blue' ? 'bg-blue-50' :
  service.accent === 'emerald' ? 'bg-emerald-50' :
  service.accent === 'teal' ? 'bg-teal-50' :
  service.accent === 'amber' ? 'bg-amber-50' :
  'bg-indigo-50'
} rounded-xl w-fit transform group-hover:scale-110 transition-transform duration-300`}>
                    {service.icon}
                  </div>
                  
                  <h3 className={`text-xl sm:text-2xl font-bold text-slate-800 mb-3 sm:mb-4 group-hover:text-${service.accent}-600 transition-colors duration-300`}>
                    {service.title}
                  </h3>
                  
                  <p className="text-slate-600 leading-relaxed mb-4 sm:mb-6 text-sm sm:text-base">
                    {service.description}
                  </p>
                  
                  
                </div>

                {/* Hover Effect Line */}
                <div className={`absolute bottom-0 left-0 w-0 h-1 bg-gradient-to-r ${service.hoverGradient} group-hover:w-full transition-all duration-500`}></div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="despre">
  <DespreNoi/>
</section>


      <section className="py-16 sm:py-20 md:py-24 bg-slate-50 relative overflow-hidden">
        <PartnersCarousel/>
      </section>

     {/* Contact Section */}
<section id="contact" className="py-8 sm:py-12  bg-gradient-to-br from-slate-900 via-blue-900 to-teal-900 text-white relative overflow-hidden">
  <div className="absolute inset-0">
    <div className="absolute top-0 left-1/4 w-64 h-64 sm:w-96 sm:h-96 bg-blue-500/10 rounded-full blur-3xl animate-pulse"></div>
    <div className="absolute bottom-0 right-1/4 w-64 h-64 sm:w-96 sm:h-96 bg-teal-500/10 rounded-full blur-3xl animate-pulse delay-1000"></div>
  </div>
  
  <div className="container mx-auto px-4 sm:px-6 relative z-10">
    <div className="text-center mb-12 sm:mb-16 md:mb-20">
      <div className="inline-block mb-4">
        <span className="bg-gradient-to-r from-blue-400 to-teal-400 text-white px-4 py-2 rounded-full text-sm font-semibold">
          CONTACTEAZĂ-NE
        </span>
      </div>
      <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 sm:mb-6">
        Hai să <span className="bg-gradient-to-r from-blue-400 to-teal-400 bg-clip-text text-transparent">vorbim</span>
      </h2>
      <p className="text-lg sm:text-xl text-slate-300 max-w-2xl mx-auto px-4">
        Suntem aici să răspundem la toate întrebările tale și să îți oferim cea mai bună ofertă
      </p>
    </div>
    
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 sm:gap-16 max-w-7xl mx-auto">
      {/* Informații de contact */}
      <div className="space-y-6 sm:space-y-8 height-auto">
        <ProtectedEmail
          variant="split"
          className="p-4 sm:p-6 bg-white/5 backdrop-blur-sm rounded-xl sm:rounded-2xl hover:bg-white/10 transition-all duration-300 cursor-pointer"
          buttonText="Email"
          iconColor="text-teal-400"
        />
      </div>

      {/* Formular de contact */}
      <div>
        <FormContact />
      </div>
    </div>
  </div>
</section>
    

      <Footer/>

      {/* Floating WhatsApp Button */}
      <div className="fixed bottom-4 sm:bottom-6 md:bottom-8 right-4 sm:right-6 md:right-8 z-50">
        <a 
          href="https://wa.me/+40745586183" 
          target="_blank" 
          rel="noopener noreferrer"
          className="group relative inline-flex items-center bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white p-3 sm:p-4 rounded-full shadow-lg hover:shadow-green-400/50 transition-all duration-300 transform hover:scale-110"
          aria-label="Trimite mesaj pe WhatsApp"
        >
          <svg 
            className="w-5 h-5 sm:w-6 sm:h-6" 
            fill="currentColor" 
            viewBox="0 0 24 24" 
            xmlns="http://www.w3.org/2000/svg" 
            aria-hidden="true"
          >
            <path d="M20.52 3.48A11.886 11.886 0 0012.005 0C5.373 0 0 5.373 0 12c0 2.114.553 4.135 1.6 5.934L0 24l6.36-1.654a11.919 11.919 0 005.646 1.477c6.627 0 12.005-5.373 12.005-12 0-3.2-1.242-6.2-3.49-8.343zm-8.518 16.436a10.153 10.153 0 01-5.123-1.42l-.366-.218-3.774.979.998-3.676-.238-.377a9.97 9.97 0 01-1.54-5.38c0-5.503 4.486-9.987 10.01-9.987 2.675 0 5.18 1.045 7.07 2.944a9.934 9.934 0 012.935 7.07c0 5.523-4.48 10.01-10.01 10.01zm5.523-7.558c-.301-.15-1.78-.878-2.055-.977-.274-.1-.473-.15-.673.15-.198.301-.77.976-.942 1.18-.173.203-.347.226-.648.075-.301-.15-1.271-.47-2.42-1.487-.894-.796-1.5-1.78-1.678-2.08-.173-.302-.018-.465.132-.615.136-.135.301-.347.452-.52.151-.174.2-.3.3-.5.1-.2.05-.374-.025-.523-.075-.15-.673-1.62-.922-2.216-.242-.58-.49-.502-.673-.512l-.573-.01c-.198 0-.52.074-.792.374s-1.04 1.016-1.04 2.476c0 1.46 1.065 2.874 1.213 3.074.15.198 2.095 3.2 5.07 4.49.708.306 1.26.49 1.69.628.71.227 1.356.195 1.867.118.57-.085 1.78-.726 2.034-1.43.254-.705.254-1.31.177-1.43-.074-.12-.274-.198-.573-.347z" />
          </svg>
          <span className="sr-only">Trimite mesaj pe WhatsApp</span>
        </a>
      </div>

      {/* Custom Styles */}
      <style>{`/* Înlocuiește stilurile existente cu acestea */
/* Îmbunătățire pentru dispozitive touch */
* {
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
  html, body {
  overflow-x: hidden;
  max-width: 100vw;
}
/* Previne zoom-ul accidental pe iOS */
input, select, textarea {
  font-size: 16px !important;
}

@keyframes gradient {
  0%, 100% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
}

@keyframes spin-slow {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

@keyframes pulse-smooth {
  0%, 100% { opacity: 0.4; transform: scale(1); }
  50% { opacity: 0.6; transform: scale(1.05); }
}

.animate-gradient {
  background-size: 300% 300%;
  animation: gradient 6s ease-in-out infinite;
}

.animate-spin-slow {
  animation: spin-slow 30s linear infinite;
}

.animate-pulse {
  animation: pulse-smooth 4s ease-in-out infinite;
}

/* Smooth scrolling îmbunătățit */
html {
  scroll-behavior: smooth;
}

* {
  scroll-behavior: smooth;
}

/* Toate tranzițiile să fie uniforme */
button, a, div, section {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
          
      `}</style>
    </div></>
  );
};

export default HomePage;